"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-daniele-del-friuli": {
    "2c253e4d": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-nuovo": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "0081b451": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-pozzo": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "445e685d": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-sacco": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "1be98954": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-sopracastello": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "ff1cb78f": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "borgo-sottoagaro": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "f1743f86": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "bronzacco": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "ebc61b26": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "centro-storico": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "722d4eaa": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "chiamanis": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "7b866c8a": [{
      "hkey": "3077364c",
      "slug": "aonedis",
      "name": "Aonedis",
      "primary": true,
      "skipSearch": false
    }],
    "localita-aonedis": [{
      "hkey": "3077364c",
      "slug": "aonedis",
      "name": "Aonedis",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "7d4e9c79": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "picaron": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }],
    "330bf898": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "skipSearch": false
    }],
    "zulins": [{
      "hkey": "a212ad24",
      "slug": "san-daniele-del-friuli",
      "name": "San Daniele del Friuli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "san-daniele-del-friuli"
    }]
  }
};
exports["default"] = _default;